import { PlusIcon } from "lucide-react";
import { Link } from "react-router";

import { CertificationsSvg } from "@/components/pieces/icons/svg/certifications";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export function EmptyCertifications() {
  return (
    <div className="max-w-content w-full">
      <Card>
        <div className="mx-6 flex flex-col items-center gap-6 rounded-md border border-dashed p-6">
          <CertificationsSvg size={50} />
          <div className="max-w-sm text-center">
            Create certifications to track and recognize people's progress
          </div>
          <Button asChild>
            <Link to="/certifications/create">
              <PlusIcon />
              Create Certification
            </Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
